export default __webpack_public_path__ + "static/media/cool-blueberries.9ff796ef.png";